/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */

export type PayoutMethodItemMethod = typeof PayoutMethodItemMethod[keyof typeof PayoutMethodItemMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PayoutMethodItemMethod = {
  BANK_TRANSFER: 'BANK_TRANSFER',
  PAYPAL: 'PAYPAL',
} as const;
